import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ListDataDto } from '../../core/common/list-data-dto';

export interface PendenciaEstadualDocumentoDto {
  id: string;
  executionId: string;
  botId: string;
  fileName: string;
  contentType: string;
  storagePath: string;
  sizeBytes: number;
  hash?: string | null;
  uploadedAt: string;
  tags: string[];
}

export interface PendenciaEstadualRelatorioParams {
  botId: string;
  competencia: string;
  tags?: string[];
  totalTagsFiltro?: number;
}

@Injectable({
  providedIn: 'root'
})
export class PendenciaEstadualService {
  private readonly serviceApi = `${environment.apiUrl}${environment.versionApi}/pendencias`;

  constructor(private readonly http: HttpClient) {}

  getList(
    page: number,
    pageSize: number,
    botId: string
  ): Observable<ListDataDto> {
    const params = new HttpParams()
      .set('botId', botId)
      .set('page', page)
      .set('pageSize', pageSize);

    return this.http.get<ListDataDto>(this.serviceApi, { params });
  }

  getFile(id: string): Observable<Blob> {
    return this.http.get(`${this.serviceApi}/${id}/arquivo`, {
      responseType: 'blob'
    });
  }

  gerarRelatorio(params: PendenciaEstadualRelatorioParams): Observable<Blob> {
    let httpParams = new HttpParams()
      .set('botId', params.botId)
      .set('competencia', params.competencia);

    if (params.totalTagsFiltro != null) {
      httpParams = httpParams.set('totalTagsFiltro', String(params.totalTagsFiltro));
    }

    for (const tag of params.tags ?? []) {
      if (tag?.trim()) {
        httpParams = httpParams.append('tags', tag.trim());
      }
    }

    return this.http.get(`${this.serviceApi}/relatorio`, {
      params: httpParams,
      responseType: 'blob'
    });
  }
}
